import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import './styles/style.css'; // Custom CSS for slider
import { toast, ToastContainer } from 'react-toastify';
import { useQuery, useQueryClient} from '@tanstack/react-query';
import ReactModal from 'react-modal';
import imageCompression from 'browser-image-compression';

function FamilyInfoUpdateClanAdd() {

    const { menu, toggleMobileMenu } = useAppLayout();
    
    const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const navigate = useNavigate();
  const queryClient = useQueryClient();


const [clanName, setClanName] = useState("");
  
  const [isSubmitting, setIsSubmitting] = useState(false);

const handleClanSubmit = async () => {
    if (!clanName.trim()) {
      toast.error("Please enter your clan name.");
      return;
    }
  
    setIsSubmitting(true);
  
    try {
      const res = await axios.post(
        `${API_URL}/reg-signup-noclan-api`,
        { clan_name: clanName },
        { withCredentials: true }
      );
  
      if (res.data.Status === "Success") {
        navigate(res.data.redirect);
      } else {
        toast.error("Failed to register clan.");
      }
    } catch (error) {
      console.error("Clan submission error:", error);
      toast.error("Something went wrong.");
    } finally {
      setIsSubmitting(false); //always reset
    }
  };


   

    return (
            <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />

                <div className="page-wrapper">
                    <div className="content container-fluid">

                    <div className="vstack gap-3">

                    <div className='row'>

                    <div className='col-3 col-md-3'>
                        </div>
                    
                                <div className='col-6 col-md-6'>
                    
                                        <div className='card'>
                                      <div className='card-body'>
                    
                                        <p style={{ fontWeight: '900'}}><center>You can register your new clan here</center></p>
                    
                    
                                  <input
                                        type="text"
                                        className="form-control mt-3"
                                        placeholder="Enter Clan Name"
                                        value={clanName}
                                        onChange={(e) => setClanName(e.target.value)}
                                        
                                        onFocus={(e) => e.target.scrollIntoView({ behavior: 'smooth', block: 'center' })}
                                      />
                    
                    <div className="d-flex justify-content-between align-items-center mt-4">
                      <Link onClick={() => navigate(-1)} className="btn btn-secondary">Back</Link>
                    
                      <button onClick={handleClanSubmit} 
                       type="button"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Updating..." : "Update"}
                      </button>
                    </div>
                    
                    
                    
                                        </div>
                                        </div>
                    
                                </div>
                    
                                 
                                </div>

                    </div>
                    </div>
                </div>
            </div>
        
    );
}

export default FamilyInfoUpdateClanAdd;
